import script from "./SuspectNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./SuspectNotice.vue?vue&type=script&setup=true&lang=js"

import "./SuspectNotice.vue?vue&type=style&index=0&id=6bfd9b24&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bfd9b24"]])

export default __exports__